import React, { useEffect } from "react";
import { Dropdown, Avatar, Space } from "antd";
import { LogoutOutlined, DownOutlined } from "@ant-design/icons";

import { useSelector } from "react-redux";
// users
import avatar2 from "../../../assets/images/users/avatar-4.jpg";

const ProfileMenu = () => {
  const userPhoto = useSelector((state) => state.roleReducer.o_photo);
  const userName = useSelector((state) => state.roleReducer.userName);

  const handleLogout = () => {
    sessionStorage.removeItem("sessionToken");
    sessionStorage.removeItem("sessionExpiration");
    window.location.href = "/"; // Replace "/" with the desired URL
  };

  let username = userName;
  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const uNm = obj.email.split("@")[0];
      username = uNm.charAt(0).toUpperCase() + uNm.slice(1);
    }
  }, []);

  const items = [
    {
      key: "logout",
      danger: true,
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: handleLogout,
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
      <span
        className="user-dropdown"
        style={{
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          whiteSpace: "nowrap",
        }}
      >
        <Space wrap={false}>
          <Avatar src={userPhoto || avatar2} alt="Header Avatar" />
          <span className="d-none d-lg-inline-block text-transform">
            {username}
          </span>
          <DownOutlined className="d-none d-lg-inline-block" />
        </Space>
      </span>
    </Dropdown>
  );
};

export default ProfileMenu;
